// @flow
/* eslint no-console: 0 */
import mixpanel from 'mixpanel-browser';
import eventProperties from '../eventProperties';
import {
  WAG_TAG_PAGE_MOUNTED,
  WAG_TAG_CTA_CLICKED,
  WAG_TAG_FORM_SUBMITTED,
  type TrackingEvent,
} from '../TrackingEventTypes.constants';

export class MixpanelTrackingProvider {
  // Register any events that the provider should subscribe to here
  supportedEvents = [
    WAG_TAG_PAGE_MOUNTED,
    WAG_TAG_CTA_CLICKED,
    WAG_TAG_FORM_SUBMITTED,
  ];

  constructor() {
    try {
      if (!process.env.GATSBY_MIXPANEL_TOKEN) {
        throw new Error('Mixpanel token not set');
      }

      mixpanel.init(process.env.GATSBY_MIXPANEL_TOKEN);

      if (process.env.NODE_ENV === 'development') {
        console.log('Initialized mixpanel');
      }
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.log('Mixpanel initialization error: ', e);
      }

      console.log('Unable to initialize mixpanel');
    }
  }

  track = (eventName: TrackingEvent, additionalProps: Object = {}) => {
    try {
      // Check if the event is supported by our mixpanel provider
      if (this.supportedEvents.find(supportedEvent => supportedEvent === eventName)) {
        // Get the event configuration by the event name
        const event = eventProperties[eventName];

        const combinedEvent = {
          ...event,
          ...additionalProps,
        };

        // Track the event with mixpanel
        mixpanel.track(eventName, combinedEvent);

        if (process.env.NODE_ENV === 'development') {
          console.log(`Dispatched mixpanel tracking event: ${eventName} \nWith properties:`, combinedEvent);
        }
      }
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.log(`Unable to dispatch mixpanel tracking event: ${eventName} \nWith properties:`, eventProperties[eventName]);
      }
    }
  }
}

export default MixpanelTrackingProvider;
